import { FC, ReactNode } from "react"

interface TimelineProps {
  children: ReactNode;
}

export const Timeline: FC<TimelineProps> = (props: TimelineProps) => {
  return (
    <div className="timeline">
      {props.children}
    </div>
  )
}